import React from 'react';

const paths = {
  home: (
    <>
      <path d="M3 11l9-8 9 8" />
      <path d="M5 10v10h14V10" />
    </>
  ),
  learn: (
    <>
      <path d="M4 5a2 2 0 0 1 2-2h12v18H6a2 2 0 0 1-2-2z" />
      <path d="M18 17H6" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
      <path d="M9 12l2 2 4-4" />
    </>
  ),
  pulse: <path d="M3 12h4l2 6 4-14 2 8h6" />,
  board: (
    <>
      <rect x="3" y="3" width="6" height="18" rx="1" />
      <rect x="10" y="3" width="6" height="12" rx="1" />
      <rect x="17" y="3" width="4" height="8" rx="1" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </>
  ),
  admin: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
      <path d="M17 3l1.2 2.2L21 5.6" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M15 16.5a5 5 0 0 1 6 3.5" />
    </>
  ),
  paint: (
    <>
      <path d="M4 13a8 8 0 1 1 8 8h-1.5a2 2 0 0 1 0-4H12a2 2 0 0 0 0-4H4z" />
      <circle cx="8" cy="10" r=".5" />
      <circle cx="11" cy="7" r=".5" />
      <circle cx="15" cy="9" r=".5" />
    </>
  ),
  menu: (
    <>
      <path d="M4 6h16" />
      <path d="M4 12h16" />
      <path d="M4 18h16" />
    </>
  ),
  arrow: (
    <>
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </>
  ),
  github: (
    <>
      <path d="M6 3v12" />
      <circle cx="6" cy="18" r="2.5" />
      <circle cx="18" cy="6" r="2.5" />
      <path d="M18 8.5a9 9 0 0 1-9 9" />
    </>
  ),
  alert: (
    <>
      <path d="M12 3l9 16H3z" />
      <path d="M12 9v4" />
      <path d="M12 16h.01" />
    </>
  ),
  check: <path d="M20 6L9 17l-5-5" />,
  logout: (
    <>
      <path d="M10 5H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4" />
      <path d="M14 16l4-4-4-4" />
      <path d="M18 12H9" />
    </>
  ),
};

function ForgeIcon({ name, className = '' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name] || paths.home}
    </svg>
  );
}

export default ForgeIcon;
